export const SYSTEM_BACKUP_SECTION_EVENT =
	'canvas-agent:system-backup:section';
export const SYSTEM_BACKUP_FILTER_EVENT = 'canvas-agent:system-backup:filter';
export const SYSTEM_BACKUP_FOCUS_EVENT = 'canvas-agent:system-backup:focus';
export const SYSTEM_BACKUP_CREATE_MODAL_EVENT =
	'canvas-agent:system-backup:create-modal';
export const SYSTEM_BACKUP_UPLOAD_MODAL_EVENT =
	'canvas-agent:system-backup:upload-modal';
export const SYSTEM_BACKUP_RESTORE_MODAL_EVENT =
	'canvas-agent:system-backup:restore-modal';
export const SYSTEM_BACKUP_DELETE_MODAL_EVENT =
	'canvas-agent:system-backup:delete-modal';
